<template>
   <span class="duplicate-item-btn" v-b-tooltip.hover title="کپی" @click="duplicateItem()">
     <b-icon icon="files"/>
   </span>
</template>

<script>
export default {
  name: "DuplicateItem",
  props: {
    item: {
      default: null
    },
    itemType: {
      default: null
    },
  },
  data() {
    return {
      typeAttributes: {
        product: {
          route: {name: 'EditProduct', params: {slug: ''}},
          type: 'product',
        },
        course: {
          route: {name: 'EditCourse', params: {slug: ''}},
          type: 'course',
        },
        post: {
          route: {name: 'UpdateContent', params: {slug: ''}},
          type: 'content',
        },
        page: {
          route: {name: 'UpdateContent', params: {slug: ''}},
          type: 'content',
        },
        lesson: {
          route: {name: 'UpdateLessons', params: {slug: ''}},
          type: 'content',
        },
      }
    }
  },
  methods: {
    duplicateItem() {
      const selectedType = this.typeAttributes[this.itemType]
      if (confirm('از کپی کردن مورد انتخاب شده اطمینان دارید؟')) {
        const form = {
          item_type: selectedType.type,
          item_id: this.item.id
        }

        this.$store.dispatch('Content/duplicateItem', form)
            .then((res) => {
              const data = res.data.data
              let route = selectedType.route;
              if (this.itemType == 'product') {
                route.params.slug = data.raw_link
              } else {
                route.params.slug = data.slug
              }

              const routeData = this.$router.resolve(route);
              window.open(routeData.href, '_blank');

            })
            .catch((error) => {
              console.log(error);
            });
      }

    }
  }
}
</script>

<style scoped>
.duplicate-item-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>